module.exports = __webpack_public_path__ + "img/card_invoice_intervention.e59b388b.svg";